export const RESET_MESSAGE = 'RESET_MESSAGE';

export const LOGIN_PROGRESS = "LOGIN_PROGRESS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_PROGRESS = "LOGOUT_PROGRESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

// ---------------------- Customer Master -------------------------

export const GET_CUSTOMER_LIST_PROGRESS = "GET_CUSTOMER_LIST_PROGRESS";
export const GET_CUSTOMER_LIST_SUCCESS = "GET_CUSTOMER_LIST_SUCCESS";
export const GET_CUSTOMER_LIST_FAILURE = "GET_CUSTOMER_LIST_FAILURE";

export const ADD_CUSTOMER_PROGRESS = "ADD_CUSTOMER_PROGRESS";
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS";
export const ADD_CUSTOMER_FAILURE = "ADD_CUSTOMER_FAILURE";


export const EDIT_DELETE_CUSTOMER_PROGRESS = "EDIT_DELETE_CUSTOMER_PROGRESS";
export const EDIT_DELETE_CUSTOMER_SUCCESS = "EDIT_DELETE_CUSTOMER_SUCCESS";
export const EDIT_DELETE_CUSTOMER_FAILURE = "EDIT_DELETE_CUSTOMER_FAILURE";

export const ADD_IMPORT_CUSTOMER_PROGRESS = "ADD_IMPORT_CUSTOMER_PROGRESS";
export const ADD_IMPORT_CUSTOMER_SUCCESS = "ADD_IMPORT_CUSTOMER_SUCCESS";
export const ADD_IMPORT_CUSTOMER_FAILURE = "ADD_IMPORT_CUSTOMER_FAILURE";

// ---------------------- Cylinder holding limit Master -------------------------

export const GET_CYLINDER_HOLDING_LIMIT_LIST_PROGRESS = "GET_CYLINDER_HOLDING_LIMIT_LIST_PROGRESS";
export const GET_CYLINDER_HOLDING_LIMIT_LIST_SUCCESS = "GET_CYLINDER_HOLDING_LIMIT_LIST_SUCCESS";
export const GET_CYLINDER_HOLDING_LIMIT_LIST_FAILURE = "GET_CYLINDER_HOLDING_LIMIT_LIST_FAILURE";

export const ADD_CYLINDER_HOLDING_LIMIT_PROGRESS = "ADD_CYLINDER_HOLDING_LIMIT_PROGRESS";
export const ADD_CYLINDER_HOLDING_LIMIT_SUCCESS = "ADD_CYLINDER_HOLDING_LIMIT_SUCCESS";
export const ADD_CYLINDER_HOLDING_LIMIT_FAILURE = "ADD_CYLINDER_HOLDING_LIMIT_FAILURE";

export const EDIT_DELETE_CYLINDER_HOLDING_LIMIT_PROGRESS = "EDIT_DELETE_CYLINDER_HOLDING_LIMIT_PROGRESS";
export const EDIT_DELETE_CYLINDER_HOLDING_LIMIT_SUCCESS = "EDIT_DELETE_CYLINDER_HOLDING_LIMIT_SUCCESS";
export const EDIT_DELETE_CYLINDER_HOLDING_LIMIT_FAILURE = "EDIT_DELETE_CYLINDER_HOLDING_LIMIT_FAILURE";

// ---------------------- cylinder Master -------------------------

export const GET_CYLINDER_LIST_PROGRESS = "GET_CYLINDER_LIST_PROGRESS";
export const GET_CYLINDER_LIST_SUCCESS = "GET_CYLINDER_LIST_SUCCESS";
export const GET_CYLINDER_LIST_FAILURE = "GET_CYLINDER_LIST_FAILURE";

export const ADD_CYLINDER_PROGRESS = "ADD_CYLINDER_PROGRESS";
export const ADD_CYLINDER_SUCCESS = "ADD_CYLINDER_SUCCESS";
export const ADD_CYLINDER_FAILURE = "ADD_CYLINDER_FAILURE";

export const ADD_CYLINDER_CSV_PROGRESS = "ADD_CYLINDER_CSV_PROGRESS";
export const ADD_CYLINDER_CSV_SUCCESS = "ADD_CYLINDER_CSV_SUCCESS";
export const ADD_CYLINDER_CSV_FAILURE = "ADD_CYLINDER_CSV_FAILURE";

export const EDIT_DELETE_CYLINDER_PROGRESS = "EDIT_DELETE_CYLINDER_PROGRESS";
export const EDIT_DELETE_CYLINDER_SUCCESS = "EDIT_DELETE_CYLINDER_SUCCESS";
export const EDIT_DELETE_CYLINDER_FAILURE = "EDIT_DELETE_CYLINDER_FAILURE";

// ---------------------- Industry Master -------------------------

export const GET_INDUSTRY_LIST_PROGRESS = "GET_INDUSTRY_LIST_PROGRESS";
export const GET_INDUSTRY_LIST_SUCCESS = "GET_INDUSTRY_LIST_SUCCESS";
export const GET_INDUSTRY_LIST_FAILURE = "GET_INDUSTRY_LIST_FAILURE";

export const ADD_INDUSTRY_PROGRESS = "ADD_INDUSTRY_PROGRESS";
export const ADD_INDUSTRY_SUCCESS = "ADD_INDUSTRY_SUCCESS";
export const ADD_INDUSTRY_FAILURE = "ADD_INDUSTRY_FAILURE";

export const EDIT_DELETE_INDUSTRY_PROGRESS = "EDIT_DELETE_INDUSTRY_PROGRESS";
export const EDIT_DELETE_INDUSTRY_SUCCESS = "EDIT_DELETE_INDUSTRY_SUCCESS";
export const EDIT_DELETE_INDUSTRY_FAILURE = "EDIT_DELETE_INDUSTRY_FAILURE";

// ---------------------- Customer Type Master -------------------------

export const GET_CUSTOMER_TYPE_LIST_PROGRESS = "GET_CUSTOMER_TYPE_LIST_PROGRESS";
export const GET_CUSTOMER_TYPE_LIST_SUCCESS = "GET_CUSTOMER_TYPE_LIST_SUCCESS";
export const GET_CUSTOMER_TYPE_LIST_FAILURE = "GET_CUSTOMER_TYPE_LIST_FAILURE";

export const ADD_CUSTOMER_TYPE_PROGRESS = "ADD_CUSTOMER_TYPE_PROGRESS";
export const ADD_CUSTOMER_TYPE_SUCCESS = "ADD_CUSTOMER_TYPE_SUCCESS";
export const ADD_CUSTOMER_TYPE_FAILURE = "ADD_CUSTOMER_TYPE_FAILURE";

export const EDIT_DELETE_CUSTOMER_TYPE_PROGRESS = "EDIT_DELETE_CUSTOMER_TYPE_PROGRESS";
export const EDIT_DELETE_CUSTOMER_TYPE_SUCCESS = "EDIT_DELETE_CUSTOMER_TYPE_SUCCESS";
export const EDIT_DELETE_CUSTOMER_TYPE_FAILURE = "EDIT_DELETE_CUSTOMER_TYPE_FAILURE";

// ---------------------- Customer Category Master -------------------------

export const GET_CUSTOMER_CATEGORY_LIST_PROGRESS = "GET_CUSTOMER_CATEGORY_LIST_PROGRESS";
export const GET_CUSTOMER_CATEGORY_LIST_SUCCESS = "GET_CUSTOMER_CATEGORY_LIST_SUCCESS";
export const GET_CUSTOMER_CATEGORY_LIST_FAILURE = "GET_CUSTOMER_CATEGORY_LIST_FAILURE";

export const ADD_CUSTOMER_CATEGORY_PROGRESS = "ADD_CUSTOMER_CATEGORY_PROGRESS";
export const ADD_CUSTOMER_CATEGORY_SUCCESS = "ADD_CUSTOMER_CATEGORY_SUCCESS";
export const ADD_CUSTOMER_CATEGORY_FAILURE = "ADD_CUSTOMER_CATEGORY_FAILURE";

export const EDIT_DELETE_CUSTOMER_CATEGORY_PROGRESS = "EDIT_DELETE_CUSTOMER_CATEGORY_PROGRESS";
export const EDIT_DELETE_CUSTOMER_CATEGORY_SUCCESS = "EDIT_DELETE_CUSTOMER_CATEGORY_SUCCESS";
export const EDIT_DELETE_CUSTOMER_CATEGORY_FAILURE = "EDIT_DELETE_CUSTOMER_CATEGORY_FAILURE"

// ---------------------- Cylinder Status Master -------------------------

export const GET_CYLINDER_STATUS_LIST_PROGRESS = "GET_CYLINDER_STATUS_LIST_PROGRESS";
export const GET_CYLINDER_STATUS_LIST_SUCCESS = "GET_CYLINDER_STATUS_LIST_SUCCESS";
export const GET_CYLINDER_STATUS_LIST_FAILURE = "GET_CYLINDER_STATUS_LIST_FAILURE";

export const ADD_CYLINDER_STATUS_PROGRESS = "ADD_CYLINDER_STATUS_PROGRESS";
export const ADD_CYLINDER_STATUS_SUCCESS = "ADD_CYLINDER_STATUS_SUCCESS";
export const ADD_CYLINDER_STATUS_FAILURE = "ADD_CYLINDER_STATUS_FAILURE";

export const EDIT_DELETE_CYLINDER_STATUS_PROGRESS = "EDIT_DELETE_CYLINDER_STATUS_PROGRESS";
export const EDIT_DELETE_CYLINDER_STATUS_SUCCESS = "EDIT_DELETE_CYLINDER_STATUS_SUCCESS";
export const EDIT_DELETE_CYLINDER_STATUS_FAILURE = "EDIT_DELETE_CYLINDER_STATUS_FAILURE";

// ---------------------- Unit Master -------------------------

export const GET_UNIT_LIST_PROGRESS = "GET_UNIT_LIST_PROGRESS";
export const GET_UNIT_LIST_SUCCESS = "GET_UNIT_LIST_SUCCESS";
export const GET_UNIT_LIST_FAILURE = "GET_UNIT_LIST_FAILURE";

export const ADD_UNIT_PROGRESS = "ADD_UNIT_PROGRESS";
export const ADD_UNIT_SUCCESS = "ADD_UNIT_SUCCESS";
export const ADD_UNIT_FAILURE = "ADD_UNIT_FAILURE";

export const EDIT_DELETE_UNIT_PROGRESS = "EDIT_DELETE_UNIT_PROGRESS";
export const EDIT_DELETE_UNIT_SUCCESS = "EDIT_DELETE_UNIT_SUCCESS";
export const EDIT_DELETE_UNIT_FAILURE = "EDIT_DELETE_UNIT_FAILURE";

// ---------------------- Depot Master -------------------------

export const GET_DEPOT_LIST_PROGRESS = "GET_DEPOT_LIST_PROGRESS";
export const GET_DEPOT_LIST_SUCCESS = "GET_DEPOT_LIST_SUCCESS";
export const GET_DEPOT_LIST_FAILURE = "GET_DEPOT_LIST_FAILURE";

export const ADD_DEPOT_PROGRESS = "ADD_DEPOT_PROGRESS";
export const ADD_DEPOT_SUCCESS = "ADD_DEPOT_SUCCESS";
export const ADD_DEPOT_FAILURE = "ADD_DEPOT_FAILURE";

export const EDIT_DELETE_DEPOT_PROGRESS = "EDIT_DELETE_DEPOT_PROGRESS";
export const EDIT_DELETE_DEPOT_SUCCESS = "EDIT_DELETE_DEPOT_SUCCESS";
export const EDIT_DELETE_DEPOT_FAILURE = "EDIT_DELETE_DEPOT_FAILURE";

// ---------------------- Rate Master -------------------------

export const GET_RATE_LIST_PROGRESS = "GET_RATE_LIST_PROGRESS";
export const GET_RATE_LIST_SUCCESS = "GET_RATE_LIST_SUCCESS";
export const GET_RATE_LIST_FAILURE = "GET_RATE_LIST_FAILURE";

export const ADD_RATE_PROGRESS = "ADD_RATE_PROGRESS";
export const ADD_RATE_SUCCESS = "ADD_RATE_SUCCESS";
export const ADD_RATE_FAILURE = "ADD_RATE_FAILURE";

export const EDIT_DELETE_RATE_PROGRESS = "EDIT_DELETE_RATE_PROGRESS";
export const EDIT_DELETE_RATE_SUCCESS = "EDIT_DELETE_RATE_SUCCESS";
export const EDIT_DELETE_RATE_FAILURE = "EDIT_DELETE_RATE_FAILURE";

// ---------------------- RM Master -------------------------

export const GET_RM_LIST_PROGRESS = "GET_RM_LIST_PROGRESS";
export const GET_RM_LIST_SUCCESS = "GET_RM_LIST_SUCCESS";
export const GET_RM_LIST_FAILURE = "GET_RM_LIST_FAILURE";

export const ADD_RM_PROGRESS = "ADD_RM_PROGRESS";
export const ADD_RM_SUCCESS = "ADD_RM_SUCCESS";
export const ADD_RM_FAILURE = "ADD_RM_FAILURE";

export const EDIT_DELETE_RM_PROGRESS = "EDIT_DELETE_RM_PROGRESS";
export const EDIT_DELETE_RM_SUCCESS = "EDIT_DELETE_RM_SUCCESS";
export const EDIT_DELETE_RM_FAILURE = "EDIT_DELETE_RM_FAILURE";

// ---------------------- Account Manager Master -------------------------

export const GET_ACCOUNT_MANAGER_LIST_PROGRESS = "GET_ACCOUNT_MANAGER_LIST_PROGRESS";
export const GET_ACCOUNT_MANAGER_LIST_SUCCESS = "GET_ACCOUNT_MANAGER_LIST_SUCCESS";
export const GET_ACCOUNT_MANAGER_LIST_FAILURE = "GET_ACCOUNT_MANAGER_LIST_FAILURE";

export const ADD_ACCOUNT_MANAGER_PROGRESS = "ADD_ACCOUNT_MANAGER_PROGRESS";
export const ADD_ACCOUNT_MANAGER_SUCCESS = "ADD_ACCOUNT_MANAGER_SUCCESS";
export const ADD_ACCOUNT_MANAGER_FAILURE = "ADD_ACCOUNT_MANAGER_FAILURE";

export const EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS = "EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS";
export const EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS = "EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS";
export const EDIT_DELETE_ACCOUNT_MANAGER_FAILURE = "EDIT_DELETE_ACCOUNT_MANAGER_FAILURE";

// ---------------------- Customer Product Details Master -------------------------

export const GET_CPD_LIST_PROGRESS = "GET_CPD_LIST_PROGRESS";
export const GET_CPD_LIST_SUCCESS = "GET_CPD_LIST_SUCCESS";
export const GET_CPD_LIST_FAILURE = "GET_CPD_LIST_FAILURE";

export const ADD_CPD_PROGRESS = "ADD_CPD_PROGRESS";
export const ADD_CPD_SUCCESS = "ADD_CPD_SUCCESS";
export const ADD_CPD_FAILURE = "ADD_CPD_FAILURE";

export const EDIT_DELETE_CPD_PROGRESS = "EDIT_DELETE_CPD_PROGRESS";
export const EDIT_DELETE_CPD_SUCCESS = "EDIT_DELETE_CPD_SUCCESS";
export const EDIT_DELETE_CPD_FAILURE = "EDIT_DELETE_CPD_FAILURE";



// ----------------------- cylinder tag mapping -------------------------

export const GET_CYLINDER_TAG_MAPPING_LIST_PROGRESS = "GET_CYLINDER_TAG_MAPPING_LIST_PROGRESS";
export const GET_CYLINDER_TAG_MAPPING_LIST_SUCCESS = "GET_CYLINDER_TAG_MAPPING_LIST_SUCCESS";
export const GET_CYLINDER_TAG_MAPPING_LIST_FAILURE = "GET_CYLINDER_TAG_MAPPING_LIST_FAILURE";

export const ADD_CYLINDER_TAG_MAPPING_PROGRESS = "ADD_CYLINDER_TAG_MAPPING_PROGRESS";
export const ADD_CYLINDER_TAG_MAPPING_SUCCESS = "ADD_CYLINDER_TAG_MAPPING_SUCCESS";
export const ADD_CYLINDER_TAG_MAPPING_FAILURE = "ADD_CYLINDER_TAG_MAPPING_FAILURE";

export const EDIT_DELETE_CYLINDER_TAG_MAPPING_PROGRESS = "EDIT_DELETE_CYLINDER_TAG_MAPPING_PROGRESS";
export const EDIT_DELETE_CYLINDER_TAG_MAPPING_SUCCESS = "EDIT_DELETE_CYLINDER_TAG_MAPPING_SUCCESS";
export const EDIT_DELETE_CYLINDER_TAG_MAPPING_FAILURE = "EDIT_DELETE_CYLINDER_TAG_MAPPING_FAILURE";



// ---------------------- UOM conversion Master -------------------------

export const GET_UOM_CONVERSION_LIST_PROGRESS = "GET_UOM_CONVERSION_LIST_PROGRESS";
export const GET_UOM_CONVERSION_LIST_SUCCESS = "GET_UOM_CONVERSION_LIST_SUCCESS";
export const GET_UOM_CONVERSION_LIST_FAILURE = "GET_UOM_CONVERSION_LIST_FAILURE";

export const ADD_UOM_CONVERSION_PROGRESS = "ADD_UOM_CONVERSION_PROGRESS";
export const ADD_UOM_CONVERSION_SUCCESS = "ADD_UOM_CONVERSION_SUCCESS";
export const ADD_UOM_CONVERSION_FAILURE = "ADD_UOM_CONVERSION_FAILURE";

export const EDIT_DELETE_UOM_CONVERSION_PROGRESS = "EDIT_DELETE_UOM_CONVERSION_PROGRESS";
export const EDIT_DELETE_UOM_CONVERSION_SUCCESS = "EDIT_DELETE_UOM_CONVERSION_SUCCESS";
export const EDIT_DELETE_UOM_CONVERSION_FAILURE = "EDIT_DELETE_UOM_CONVERSION_FAILURE";

// ---------------------- UOM Master -------------------------

export const GET_UOM_LIST_PROGRESS = "GET_UOM_LIST_PROGRESS";
export const GET_UOM_LIST_SUCCESS = "GET_UOM_LIST_SUCCESS";
export const GET_UOM_LIST_FAILURE = "GET_UOM_LIST_FAILURE";

export const ADD_UOM_PROGRESS = "ADD_UOM_PROGRESS";
export const ADD_UOM_SUCCESS = "ADD_UOM_SUCCESS";
export const ADD_UOM_FAILURE = "ADD_UOM_FAILURE";

export const EDIT_DELETE_UOM_PROGRESS = "EDIT_DELETE_UOM_PROGRESS";
export const EDIT_DELETE_UOM_SUCCESS = "EDIT_DELETE_UOM_SUCCESS";
export const EDIT_DELETE_UOM_FAILURE = "EDIT_DELETE_UOM_FAILURE";

// ---------------------- LOCATION Master -------------------------

export const GET_LOCATION_LIST_PROGRESS = "GET_LOCATION_LIST_PROGRESS";
export const GET_LOCATION_LIST_SUCCESS = "GET_LOCATION_LIST_SUCCESS";
export const GET_LOCATION_LIST_FAILURE = "GET_LOCATION_LIST_FAILURE";

export const ADD_LOCATION_PROGRESS = "ADD_LOCATION_PROGRESS";
export const ADD_LOCATION_SUCCESS = "ADD_LOCATION_SUCCESS";
export const ADD_LOCATION_FAILURE = "ADD_LOCATION_FAILURE";

export const EDIT_DELETE_LOCATION_PROGRESS = "EDIT_DELETE_LOCATION_PROGRESS";
export const EDIT_DELETE_LOCATION_SUCCESS = "EDIT_DELETE_LOCATION_SUCCESS";
export const EDIT_DELETE_LOCATION_FAILURE = "EDIT_DELETE_LOCATION_FAILURE";


// ---------------------- Supplier Master -------------------------

export const GET_SUPPLIER_LIST_PROGRESS = "GET_SUPPLIER_LIST_PROGRESS";
export const GET_SUPPLIER_LIST_SUCCESS = "GET_SUPPLIER_LIST_SUCCESS";
export const GET_SUPPLIER_LIST_FAILURE = "GET_SUPPLIER_LIST_FAILURE";

export const ADD_SUPPLIER_PROGRESS = "ADD_SUPPLIER_PROGRESS";
export const ADD_SUPPLIER_SUCCESS = "ADD_SUPPLIER_SUCCESS";
export const ADD_SUPPLIER_FAILURE = "ADD_SUPPLIER_FAILURE";

export const EDIT_DELETE_SUPPLIER_PROGRESS = "EDIT_DELETE_SUPPLIER_PROGRESS";
export const EDIT_DELETE_SUPPLIER_SUCCESS = "EDIT_DELETE_SUPPLIER_SUCCESS";
export const EDIT_DELETE_SUPPLIER_FAILURE = "EDIT_DELETE_SUPPLIER_FAILURE";

export const ADD_IMPORT_SUPPLIER_PROGRESS = "ADD_IMPORT_SUPPLIER_PROGRESS";
export const ADD_IMPORT_SUPPLIER_SUCCESS = "ADD_IMPORT_SUPPLIER_SUCCESS";
export const ADD_IMPORT_SUPPLIER_FAILURE = "ADD_IMPORT_SUPPLIER_FAILURE";

// ---------------------- Driver Master -------------------------

export const GET_DRIVER_LIST_PROGRESS = "GET_DRIVER_LIST_PROGRESS";
export const GET_DRIVER_LIST_SUCCESS = "GET_DRIVER_LIST_SUCCESS";
export const GET_DRIVER_LIST_FAILURE = "GET_DRIVER_LIST_FAILURE";

export const ADD_DRIVER_PROGRESS = "ADD_DRIVER_PROGRESS";
export const ADD_DRIVER_SUCCESS = "ADD_DRIVER_SUCCESS";
export const ADD_DRIVER_FAILURE = "ADD_DRIVER_FAILURE";

export const EDIT_DELETE_DRIVER_PROGRESS = "EDIT_DELETE_DRIVER_PROGRESS";
export const EDIT_DELETE_DRIVER_SUCCESS = "EDIT_DELETE_DRIVER_SUCCESS";
export const EDIT_DELETE_DRIVER_FAILURE = "EDIT_DELETE_DRIVER_FAILURE";


// ---------------------- User Master -------------------------

export const GET_USER_LIST_PROGRESS = "GET_USER_LIST_PROGRESS";
export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS";
export const GET_USER_LIST_FAILURE = "GET_USER_LIST_FAILURE";

export const ADD_USER_PROGRESS = "ADD_USER_PROGRESS";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_FAILURE = "ADD_USER_FAILURE";

export const EDIT_DELETE_USER_PROGRESS = "EDIT_DELETE_USER_PROGRESS";
export const EDIT_DELETE_USER_SUCCESS = "EDIT_DELETE_USER_SUCCESS";
export const EDIT_DELETE_USER_FAILURE = "EDIT_DELETE_USER_FAILURE";


// ---------------------- Vehicle Master -------------------------

export const GET_VEHICLE_LIST_PROGRESS = "GET_VEHICLE_LIST_PROGRESS";
export const GET_VEHICLE_LIST_SUCCESS = "GET_VEHICLE_LIST_SUCCESS";
export const GET_VEHICLE_LIST_FAILURE = "GET_VEHICLE_LIST_FAILURE";

export const ADD_VEHICLE_PROGRESS = "ADD_VEHICLE_PROGRESS";
export const ADD_VEHICLE_SUCCESS = "ADD_VEHICLE_SUCCESS";
export const ADD_VEHICLE_FAILURE = "ADD_VEHICLE_FAILURE";

export const EDIT_DELETE_VEHICLE_PROGRESS = "EDIT_DELETE_VEHICLE_PROGRESS";
export const EDIT_DELETE_VEHICLE_SUCCESS = "EDIT_DELETE_VEHICLE_SUCCESS";
export const EDIT_DELETE_VEHICLE_FAILURE = "EDIT_DELETE_VEHICLE_FAILURE";


// ---------------------- Route Master -------------------------

export const GET_ROUTE_LIST_PROGRESS = "GET_ROUTE_LIST_PROGRESS";
export const GET_ROUTE_LIST_SUCCESS = "GET_ROUTE_LIST_SUCCESS";
export const GET_ROUTE_LIST_FAILURE = "GET_ROUTE_LIST_FAILURE";

export const ADD_ROUTE_PROGRESS = "ADD_ROUTE_PROGRESS";
export const ADD_ROUTE_SUCCESS = "ADD_ROUTE_SUCCESS";
export const ADD_ROUTE_FAILURE = "ADD_ROUTE_FAILURE";

export const EDIT_DELETE_ROUTE_PROGRESS = "EDIT_DELETE_ROUTE_PROGRESS";
export const EDIT_DELETE_ROUTE_SUCCESS = "EDIT_DELETE_ROUTE_SUCCESS";
export const EDIT_DELETE_ROUTE_FAILURE = "EDIT_DELETE_ROUTE_FAILURE";


// ---------------------- Driver Master -------------------------

export const GET_PRODUCT_LIST_PROGRESS = "GET_PRODUCT_LIST_PROGRESS";
export const GET_PRODUCT_LIST_SUCCESS = "GET_PRODUCT_LIST_SUCCESS";
export const GET_PRODUCT_LIST_FAILURE = "GET_PRODUCT_LIST_FAILURE";

export const ADD_PRODUCT_PROGRESS = "ADD_PRODUCT_PROGRESS";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE";

export const EDIT_DELETE_PRODUCT_PROGRESS = "EDIT_DELETE_PRODUCT_PROGRESS";
export const EDIT_DELETE_PRODUCT_SUCCESS = "EDIT_DELETE_PRODUCT_SUCCESS";
export const EDIT_DELETE_PRODUCT_FAILURE = "EDIT_DELETE_PRODUCT_FAILURE";


// ======================= Transactions =======================================

// ---------------------- Delivery Challan -------------------------

export const GET_DELIVERY_CHALLAN_LIST_PROGRESS = "GET_DELIVERY_CHALLAN_LIST_PROGRESS";
export const GET_DELIVERY_CHALLAN_LIST_SUCCESS = "GET_DELIVERY_CHALLAN_LIST_SUCCESS";
export const GET_DELIVERY_CHALLAN_LIST_FAILURE = "GET_DELIVERY_CHALLAN_LIST_FAILURE";

export const ADD_DELIVERY_CHALLAN_PROGRESS = "ADD_DELIVERY_CHALLAN_PROGRESS";
export const ADD_DELIVERY_CHALLAN_SUCCESS = "ADD_DELIVERY_CHALLAN_SUCCESS";
export const ADD_DELIVERY_CHALLAN_FAILURE = "ADD_DELIVERY_CHALLAN_FAILURE";

export const EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS = "EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS";
export const EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS = "EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS";
export const EDIT_DELETE_DELIVERY_CHALLAN_FAILURE = "EDIT_DELETE_DELIVERY_CHALLAN_FAILURE";

// ---------------------- Delivery Challan -------------------------

export const GET_DELIVERY_ORDER_LIST_PROGRESS = "GET_DELIVERY_ORDER_LIST_PROGRESS";
export const GET_DELIVERY_ORDER_LIST_SUCCESS = "GET_DELIVERY_ORDER_LIST_SUCCESS";
export const GET_DELIVERY_ORDER_LIST_FAILURE = "GET_DELIVERY_ORDER_LIST_FAILURE";

export const ADD_DELIVERY_ORDER_PROGRESS = "ADD_DELIVERY_ORDER_PROGRESS";
export const ADD_DELIVERY_ORDER_SUCCESS = "ADD_DELIVERY_ORDER_SUCCESS";
export const ADD_DELIVERY_ORDER_FAILURE = "ADD_DELIVERY_ORDER_FAILURE";

export const EDIT_DELETE_DELIVERY_ORDER_PROGRESS = "EDIT_DELETE_DELIVERY_ORDER_PROGRESS";
export const EDIT_DELETE_DELIVERY_ORDER_SUCCESS = "EDIT_DELETE_DELIVERY_ORDER_SUCCESS";
export const EDIT_DELETE_DELIVERY_ORDER_FAILURE = "EDIT_DELETE_DELIVERY_ORDER_FAILURE";

// ---------------------- Delivery Challan customer-------------------------

export const GET_DELIVERY_CHALLAN_CUSTOMER_LIST_PROGRESS = "GET_DELIVERY_CHALLAN_CUSTOMER_LIST_PROGRESS";
export const GET_DELIVERY_CHALLAN_CUSTOMER_LIST_SUCCESS = "GET_DELIVERY_CHALLAN_CUSTOMER_LIST_SUCCESS";
export const GET_DELIVERY_CHALLAN_CUSTOMER_LIST_FAILURE = "GET_DELIVERY_CHALLAN_CUSTOMER_LIST_FAILURE";

export const ADD_DELIVERY_CHALLAN_CUSTOMER_PROGRESS = "ADD_DELIVERY_CHALLAN_CUSTOMER_PROGRESS";
export const ADD_DELIVERY_CHALLAN_CUSTOMER_SUCCESS = "ADD_DELIVERY_CHALLAN_CUSTOMER_SUCCESS";
export const ADD_DELIVERY_CHALLAN_CUSTOMER_FAILURE = "ADD_DELIVERY_CHALLAN_CUSTOMER_FAILURE";

export const EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_PROGRESS = "EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_PROGRESS";
export const EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_SUCCESS = "EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_SUCCESS";
export const EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_FAILURE = "EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_FAILURE";

// ---------------------- grn -------------------------
export const GET_GRN_LIST_PROGRESS = "GET_GRN_LIST_PROGRESS";
export const GET_GRN_LIST_SUCCESS = "GET_GRN_LIST_SUCCESS";
export const GET_GRN_LIST_FAILURE = "GET_GRN_LIST_FAILURE";

export const ADD_GRN_PROGRESS = "ADD_GRN_PROGRESS";
export const ADD_GRN_SUCCESS = "ADD_GRN_SUCCESS";
export const ADD_GRN_FAILURE = "ADD_GRN_FAILURE";

export const EDIT_DELETE_GRN_PROGRESS = "EDIT_DELETE_GRN_PROGRESS";
export const EDIT_DELETE_GRN_SUCCESS = "EDIT_DELETE_GRN_SUCCESS";
export const EDIT_DELETE_GRN_FAILURE = "EDIT_DELETE_GRN_FAILURE";

// ======================= Production Entries ==========================================================

// ---------------------- Schedule Entry ---------------------------------------------------

export const GET_SCHEDULE_ENTRY_LIST_PROGRESS = "GET_SCHEDULE_ENTRY_LIST_PROGRESS";
export const GET_SCHEDULE_ENTRY_LIST_SUCCESS = "GET_SCHEDULE_ENTRY_LIST_SUCCESS";
export const GET_SCHEDULE_ENTRY_LIST_FAILURE = "GET_SCHEDULE_ENTRY_LIST_FAILURE";

export const ADD_SCHEDULE_ENTRY_PROGRESS = "ADD_SCHEDULE_ENTRY_PROGRESS";
export const ADD_SCHEDULE_ENTRY_SUCCESS = "ADD_SCHEDULE_ENTRY_SUCCESS";
export const ADD_SCHEDULE_ENTRY_FAILURE = "ADD_SCHEDULE_ENTRY_FAILURE";

export const EDIT_DELETE_SCHEDULE_ENTRY_PROGRESS = "EDIT_DELETE_SCHEDULE_ENTRY_PROGRESS";
export const EDIT_DELETE_SCHEDULE_ENTRY_SUCCESS = "EDIT_DELETE_SCHEDULE_ENTRY_SUCCESS";
export const EDIT_DELETE_SCHEDULE_ENTRY_FAILURE = "EDIT_DELETE_SCHEDULE_ENTRY_FAILURE";

// ---------------------- Production Planning ---------------------------------------------------

export const GET_PRODUCTION_PLANNING_LIST_PROGRESS = "GET_PRODUCTION_PLANNING_LIST_PROGRESS";
export const GET_PRODUCTION_PLANNING_LIST_SUCCESS = "GET_PRODUCTION_PLANNING_LIST_SUCCESS";
export const GET_PRODUCTION_PLANNING_LIST_FAILURE = "GET_PRODUCTION_PLANNING_LIST_FAILURE";

export const ADD_PRODUCTION_PLANNING_PROGRESS = "ADD_PRODUCTION_PLANNING_PROGRESS";
export const ADD_PRODUCTION_PLANNING_SUCCESS = "ADD_PRODUCTION_PLANNING_SUCCESS";
export const ADD_PRODUCTION_PLANNING_FAILURE = "ADD_PRODUCTION_PLANNING_FAILURE";

export const EDIT_DELETE_PRODUCTION_PLANNING_PROGRESS = "EDIT_DELETE_PRODUCTION_PLANNING_PROGRESS";
export const EDIT_DELETE_PRODUCTION_PLANNING_SUCCESS = "EDIT_DELETE_PRODUCTION_PLANNING_SUCCESS";
export const EDIT_DELETE_PRODUCTION_PLANNING_FAILURE = "EDIT_DELETE_PRODUCTION_PLANNING_FAILURE";

// ---------------------- Production Entry ---------------------------------------------------

export const GET_PRODUCTION_ENTRY_LIST_PROGRESS = "GET_PRODUCTION_ENTRY_LIST_PROGRESS";
export const GET_PRODUCTION_ENTRY_LIST_SUCCESS = "GET_PRODUCTION_ENTRY_LIST_SUCCESS";
export const GET_PRODUCTION_ENTRY_LIST_FAILURE = "GET_PRODUCTION_ENTRY_LIST_FAILURE";

export const ADD_PRODUCTION_ENTRY_PROGRESS = "ADD_PRODUCTION_ENTRY_PROGRESS";
export const ADD_PRODUCTION_ENTRY_SUCCESS = "ADD_PRODUCTION_ENTRY_SUCCESS";
export const ADD_PRODUCTION_ENTRY_FAILURE = "ADD_PRODUCTION_ENTRY_FAILURE";

export const EDIT_DELETE_PRODUCTION_ENTRY_PROGRESS = "EDIT_DELETE_PRODUCTION_ENTRY_PROGRESS";
export const EDIT_DELETE_PRODUCTION_ENTRY_SUCCESS = "EDIT_DELETE_PRODUCTION_ENTRY_SUCCESS";
export const EDIT_DELETE_PRODUCTION_ENTRY_FAILURE = "EDIT_DELETE_PRODUCTION_ENTRY_FAILURE";

// ---------------------- Quality Entry ---------------------------------------------------

export const GET_QUALITY_ENTRY_LIST_PROGRESS = "GET_QUALITY_ENTRY_LIST_PROGRESS";
export const GET_QUALITY_ENTRY_LIST_SUCCESS = "GET_QUALITY_ENTRY_LIST_SUCCESS";
export const GET_QUALITY_ENTRY_LIST_FAILURE = "GET_QUALITY_ENTRY_LIST_FAILURE";

export const ADD_QUALITY_ENTRY_PROGRESS = "ADD_QUALITY_ENTRY_PROGRESS";
export const ADD_QUALITY_ENTRY_SUCCESS = "ADD_QUALITY_ENTRY_SUCCESS";
export const ADD_QUALITY_ENTRY_FAILURE = "ADD_QUALITY_ENTRY_FAILURE";

export const EDIT_DELETE_QUALITY_ENTRY_PROGRESS = "EDIT_DELETE_QUALITY_ENTRY_PROGRESS";
export const EDIT_DELETE_QUALITY_ENTRY_SUCCESS = "EDIT_DELETE_QUALITY_ENTRY_SUCCESS";
export const EDIT_DELETE_QUALITY_ENTRY_FAILURE = "EDIT_DELETE_QUALITY_ENTRY_FAILURE";


// ======================= Store Entries ==========================================================

// ---------------------- Empty Cylinder Inspection Master -------------------------

export const GET_ECI_LIST_PROGRESS = "GET_ECI_LIST_PROGRESS";
export const GET_ECI_LIST_SUCCESS = "GET_ECI_LIST_SUCCESS";
export const GET_ECI_LIST_FAILURE = "GET_ECI_LIST_FAILURE";

export const ADD_ECI_PROGRESS = "ADD_ECI_PROGRESS";
export const ADD_ECI_SUCCESS = "ADD_ECI_SUCCESS";
export const ADD_ECI_FAILURE = "ADD_ECI_FAILURE";

export const EDIT_DELETE_ECI_PROGRESS = "EDIT_DELETE_ECI_PROGRESS";
export const EDIT_DELETE_ECI_SUCCESS = "EDIT_DELETE_ECI_SUCCESS";
export const EDIT_DELETE_ECI_FAILURE = "EDIT_DELETE_ECIS_FAILURE";



// ---------------------- pickup Entry  -------------------------

export const GET_PICKUP_LIST_PROGRESS = "GET_PICKUP_LIST_PROGRESS";
export const GET_PICKUP_LIST_SUCCESS = "GET_PICKUP_LIST_SUCCESS";
export const GET_PICKUP_LIST_FAILURE = "GET_PICKUP_LIST_FAILURE";

export const ADD_PICKUP_PROGRESS = "ADD_PICKUP_PROGRESS";
export const ADD_PICKUP_SUCCESS = "ADD_PICKUP_SUCCESS";
export const ADD_PICKUP_FAILURE = "ADD_PICKUP_FAILURE";

export const EDIT_DELETE_PICKUP_PROGRESS = "EDIT_DELETE_PICKUP_PROGRESS";
export const EDIT_DELETE_PICKUP_SUCCESS = "EDIT_DELETE_PICKUP_SUCCESS";
export const EDIT_DELETE_PICKUP_FAILURE = "EDIT_DELETE_PICKUP_FAILURE";


// ---------------------- Cylinder Inward ---------------------------------------------------

export const GET_CYLINDER_INWARD_LIST_PROGRESS = "GET_CYLINDER_INWARD_LIST_PROGRESS";
export const GET_CYLINDER_INWARD_LIST_SUCCESS = "GET_CYLINDER_INWARD_LIST_SUCCESS";
export const GET_CYLINDER_INWARD_LIST_FAILURE = "GET_CYLINDER_INWARD_LIST_FAILURE";

export const ADD_CYLINDER_INWARD_PROGRESS = "ADD_CYLINDER_INWARD_PROGRESS";
export const ADD_CYLINDER_INWARD_SUCCESS = "ADD_CYLINDER_INWARD_SUCCESS";
export const ADD_CYLINDER_INWARD_FAILURE = "ADD_CYLINDER_INWARD_FAILURE";

export const EDIT_DELETE_CYLINDER_INWARD_PROGRESS = "EDIT_DELETE_CYLINDER_INWARD_PROGRESS";
export const EDIT_DELETE_CYLINDER_INWARD_SUCCESS = "EDIT_DELETE_CYLINDER_INWARD_SUCCESS";
export const EDIT_DELETE_CYLINDER_INWARD_FAILURE = "EDIT_DELETE_CYLINDER_INWARD_FAILURE";

// ---------------------- Internal Movement Entry ---------------------------------------------------

export const GET_INTERNAL_MOVEMENT_LIST_PROGRESS = "GET_INTERNAL_MOVEMENT_LIST_PROGRESS";
export const GET_INTERNAL_MOVEMENT_LIST_SUCCESS = "GET_INTERNAL_MOVEMENT_LIST_SUCCESS";
export const GET_INTERNAL_MOVEMENT_LIST_FAILURE = "GET_INTERNAL_MOVEMENT_LIST_FAILURE";

export const ADD_INTERNAL_MOVEMENT_PROGRESS = "ADD_INTERNAL_MOVEMENT_PROGRESS";
export const ADD_INTERNAL_MOVEMENT_SUCCESS = "ADD_INTERNAL_MOVEMENT_SUCCESS";
export const ADD_INTERNAL_MOVEMENT_FAILURE = "ADD_INTERNAL_MOVEMENT_FAILURE";

export const EDIT_DELETE_INTERNAL_MOVEMENT_PROGRESS = "EDIT_DELETE_INTERNAL_MOVEMENT_PROGRESS";
export const EDIT_DELETE_INTERNAL_MOVEMENT_SUCCESS = "EDIT_DELETE_INTERNAL_MOVEMENT_SUCCESS";
export const EDIT_DELETE_INTERNAL_MOVEMENT_FAILURE = "EDIT_DELETE_INTERNAL_MOVEMENT_FAILURE";


// ======================= Sales Entries ==========================================================


// ======================= Entries ==========================================================

// ---------------------- Customer PO -------------------------

export const GET_CUSTOMER_PO_LIST_PROGRESS = "GET_CUSTOMER_PO_LIST_PROGRESS";
export const GET_CUSTOMER_PO_LIST_SUCCESS = "GET_CUSTOMER_PO_LIST_SUCCESS";
export const GET_CUSTOMER_PO_LIST_FAILURE = "GET_CUSTOMER_PO_LIST_FAILURE";

export const ADD_CUSTOMER_PO_PROGRESS = "ADD_CUSTOMER_PO_PROGRESS";
export const ADD_CUSTOMER_PO_SUCCESS = "ADD_CUSTOMER_PO_SUCCESS";
export const ADD_CUSTOMER_PO_FAILURE = "ADD_CUSTOMER_PO_FAILURE";

export const EDIT_DELETE_CUSTOMER_PO_PROGRESS = "EDIT_DELETE_CUSTOMER_PO_PROGRESS";
export const EDIT_DELETE_CUSTOMER_PO_SUCCESS = "EDIT_DELETE_CUSTOMER_PO_SUCCESS";
export const EDIT_DELETE_CUSTOMER_PO_FAILURE = "EDIT_DELETE_CUSTOMER_PO_FAILURE";



// ======================= Utility =======================================

// ---------------------- BOM -------------------------

export const GET_BOM_LIST_PROGRESS = "GET_BOM_LIST_PROGRESS";
export const GET_BOM_LIST_SUCCESS = "GET_BOM_LIST_SUCCESS";
export const GET_BOM_LIST_FAILURE = "GET_BOM_LIST_FAILURE";

export const ADD_BOM_PROGRESS = "ADD_BOM_PROGRESS";
export const ADD_BOM_SUCCESS = "ADD_BOM_SUCCESS";
export const ADD_BOM_FAILURE = "ADD_BOM_FAILURE";

export const EDIT_DELETE_BOM_PROGRESS = "EDIT_DELETE_BOM_PROGRESS";
export const EDIT_DELETE_BOM_SUCCESS = "EDIT_DELETE_BOM_SUCCESS";
export const EDIT_DELETE_BOM_FAILURE = "EDIT_DELETE_BOM_FAILURE";
